import '../../../resources/css/admin_style.css';
import { useEffect, useState } from 'react';
import styles from './component.module.css';
import EditModal from './modal/EditModal';
import { IAM_SERVER_PROFILES, IAM_SERVER_SERVICE_USER, IAM_SERVER_TENANT, IAM_SERVER_TENANT_USER, } from '../../../utils/Config';
import axios from "../../../utils/api/axios";
// import { DialogEnum, showDialog } from '../../../utils/dialog/Dialog';
import { useTenantList } from '../../../utils/service/tenantList';
import { uploadProfileImage } from '../../../utils/api/storageApiClient'
import { InnocodeButton, useDialog } from '@intsoft/innocode-core';

/**
 * 기본정보 판넬
 * @param callback
 * @param delay
 */
function ProfilesPanel({ user, onUserUpdate}) {
  const { showDialog } = useDialog();
  const profiles = user?.sub_profile || [];
  const [showModal, setShowModal] = useState(false);
  const [addShowModal, setAddShowModal] = useState(false);
  const [editingProfile, setEditingProfile] = useState(null);
  const { tenantList, isLoading: isTenantListLoading } = useTenantList(); // ✅ tlist -> tenantList

  const handleProfileClick = async (profile) => {
    try {
      // 1. 프로필 ID 추출
      const profileId = profile.profile_id;

      // 2. 서비스와 테넌트 정보 API 병렬 요청
      const [servicesRes, tenantsRes] = await Promise.all([
        axios.get(`${IAM_SERVER_SERVICE_USER}/get/${profileId}/services`),
        axios.get(`${IAM_SERVER_TENANT_USER}/get/${profileId}/tenants`)
      ]);

      const serviceList = servicesRes.status === 200 ? servicesRes.data?.data?.map(s => s.serviceName) : [];
      const tenantNames = tenantsRes.status === 200 ? tenantsRes.data?.data?.map(t => t.tenantName) : [];
      const updatedProfile = {
        ...profile,
        service_list: serviceList,
        tenants: tenantNames
      };

      setEditingProfile(updatedProfile);
      setShowModal(true);
    } catch (error) {
      console.error("❌ 프로필 상세 조회 실패:", error);
      showDialog({
          iconType: "warning",
          type: 'error',
          title: "에러",
          message: "프로필 상세 조회 중 오류가 발생했습니다.",
          confirmText: "확인",
      });
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setAddShowModal(false)
    setEditingProfile(null);
  };

  const handleProfileUpd = async () => { 
    let finalImageUrl = editingProfile.profile_img_url;

    try {
      // 1. 새로운 이미지 파일이 있는지 확인
      if (editingProfile.profileImageFile instanceof File) { 
        // 2. 스토리지 서버로 이미지 업로드
        finalImageUrl = await uploadProfileImage(
          editingProfile.profileImageFile,
          user?.email, // userId
        );
      }

      // 3. 주 서버로 프로필 정보 업데이트
      const params = {
        profilesId: editingProfile.profile_id,
        profileName: editingProfile.profile_name,
        profileType: "general",
        profileImgUrl: finalImageUrl // ✅ 최종 이미지 URL 사용
      };

      const url = IAM_SERVER_PROFILES + "/update";
      const res = await axios.post(url, params);
      
      showDialog({
          iconType: "check",
          type: 'info',
          title: "성공",
          message:"프로필이 성공적으로 수정되었습니다.",
          confirmText: "확인",
          onConfirm: () => {
            closeModal();
          }
      });

      // showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
      if (typeof onUserUpdate === "function") {
        onUserUpdate(true);
      }

    } catch (e) {
      console.error("Profile update failed:", e);
      showDialog({
          iconType: "warning",
          type: 'error',
          title: "실패",
          message: e.response?.data?.resultMessage || "프로필 수정에 실패했습니다.",
          confirmText: "확인",
      });
      // showDialog(DialogEnum.DEFAULT, "실패", e.response?.data?.resultMessage || "프로필 수정에 실패했습니다.");
      closeModal();
    }
  };

  // 소유 중인 테넌트 확인 함수
  const checkTenants = async (userId) => {
    try {
      const url = `${IAM_SERVER_TENANT}/exist-tenant/${userId}`;
      const res = await axios.get(url);
      const { data } = res.data;
      return data;
    } catch (err) {
      console.error("테넌트 존재 여부 확인 오류", err);
      showDialog({
          iconType: "warning",
          type: 'error',
          title: "실패",
          message: err.response?.data?.resultMessage || "테넌트 정보를 불러오는 데 실패했습니다.",
          confirmText: "확인",
      });
      // showDialog(DialogEnum.DEFAULT, "오류", "테넌트 정보를 불러오는 데 실패했습니다.");
      return false;
    }
  }

  const handleProfileDel = async () => {
    // owner 권한을 가진 테넌트가 있는지 확인
    const ownedTenants = tenantList.filter(tenant => 
        tenant.profileId === editingProfile.profile_id && 
        tenant.tenantType?.toLowerCase() === 'owner'
    );

    // 소유 중인 테넌트가 있으면 삭제를 막음
    if (ownedTenants.length > 0) {
        showDialog({
            iconType: "warning",
            type: 'error',
            title: "실패",
            message: "이 프로필이 소유자(owner)인 테넌트가 있습니다.\n삭제하려면 먼저 해당 테넌트의 소유권을 다른 사용자에게 이전해야 합니다.",
            confirmText: "확인",
        });
        // showDialog(DialogEnum.DEFAULT, "삭제 불가", "이 프로필이 소유자(owner)인 테넌트가 있습니다.\n삭제하려면 먼저 해당 테넌트의 소유권을 다른 사용자에게 이전해야 합니다.");
        closeModal();
        return;
    }

    // 소유 중인 테넌트가 없으면 삭제 절차 진행
    const hasLinkedServicesOrTenants = editingProfile.service_list?.length > 0 || editingProfile.tenants?.length > 0;
    
    const confirmMessage = hasLinkedServicesOrTenants 
        ? "가입된 서비스 또는 소속된 테넌트가 있습니다.\n정말 프로필을 삭제 하시겠습니까?"
        : "정말 프로필을 삭제 하시겠습니까?";

        showDialog({
          iconType: "warning",
          type: 'delete',
          title: "프로필 삭제",
          message: confirmMessage,
          confirmText: "예",
          cancelText: "아니요",
          onConfirm: async () => {
            try {
              const res = await axios.post(`${IAM_SERVER_PROFILES}/delete/${editingProfile.profile_id}`);
              showDialog({
                iconType: "check",
                type: 'info',
                title: "성공",
                message: res.data.message || '프로필이 삭제되었습니다.',
                confirmText: "확인",
              });
              closeModal();
              if (typeof onUserUpdate === "function") {
                onUserUpdate(true);
              }
              // showDialog(DialogEnum.SUCCESS, "성공", res.data.message || '프로필이 삭제되었습니다.', closeModal);
              
            } catch (e) {
              showDialog({
                iconType: "warning",
                type: 'error',
                title: "실패",
                message: e.response?.data?.resultMessage || "프로필 삭제 중 오류가 발생했습니다.",
                confirmText: "확인", 
              });
              // showDialog(DialogEnum.DEFAULT, "실패", e.response?.data?.resultMessage || "프로필 삭제 중 오류가 발생했습니다."); 
              closeModal();
            }
          }
      });


    // showDialog(DialogEnum.CONFIRM, "프로필 삭제", confirmMessage, async () => {
    //   try {
    //     const res = await axios.post(`${IAM_SERVER_PROFILES}/delete/${editingProfile.profile_id}`);
    //     showDialog(DialogEnum.SUCCESS, "성공", res.data.message || '프로필이 삭제되었습니다.', closeModal);
    //     if (typeof onUserUpdate === "function") {
    //       onUserUpdate(true);
    //     }
    //   } catch (e) {
    //     showDialog(DialogEnum.DEFAULT, "실패", e.response?.data?.resultMessage || "프로필 삭제 중 오류가 발생했습니다."); 
    //     closeModal();
    //   }
    // });
  };

  const showAddProfile = () => {
    const addProfile = {
			profile_name: '',
      profile_img_url: ''
    };

    setEditingProfile(addProfile);
    setAddShowModal(true);
  }

  const handleAddProfile = async () => { // ✅ async 함수로 변경
    let finalImageUrl = null;

    try {
      // 1. 이미지 파일이 있는지 확인
      if (editingProfile.profileImageFile instanceof File) {
 
        // showDialog(DialogEnum.LOADING, "업로드 중", "이미지를 업로드하고 있습니다...");
        // 2. 스토리지 서버로 이미지 업로드
        finalImageUrl = await uploadProfileImage(
          editingProfile.profileImageFile,
          user?.email,
          "default-tenant" // ❗ tenantId는 실제 값으로 변경 필요
        );
      }

      // 3. 주 서버로 프로필 생성 요청
      const params = {
        unifiedProfileId: user?.email,
        profileName: editingProfile.profile_name,
        profileType: "general",
        profileImgUrl: finalImageUrl // ✅ 최종 이미지 URL 사용
      };

      const url = IAM_SERVER_PROFILES + "/create";
      const res = await axios.post(url, params);

      showDialog({
        iconType: "check",
        type: 'info',
        title: "성공",
        message: "프로필이 성공적으로 등록되었습니다.",
        confirmText: "확인",
        onConfirm: () => {
          closeModal();
        }
      });
      if (typeof onUserUpdate === "function") {
        onUserUpdate(true);
      }
      
    } catch (e) {
      console.error("Profile creation failed:", e);
      showDialog({
        iconType: "warning",
        type: 'error',
        title: "실패",
        message: e.response?.data?.resultMessage || "프로필 생성에 실패했습니다.",
        confirmText: "확인",
      });
      // showDialog(DialogEnum.DEFAULT, "실패", e.response?.data?.resultMessage || "프로필 생성에 실패했습니다.");
      closeModal();
    }
  };

return (
  <>
    {/* ✅ 모달을 infoCard 밖에서 렌더링 */}
    {showModal && (
      <EditModal
        title="프로필 수정"
        type="profile"
        value={editingProfile}
        onChange={setEditingProfile}
        onClose={closeModal}
        onSave={handleProfileUpd}
        onDelete={handleProfileDel}
      />
    )}

    {addShowModal && (
      <EditModal
        title="프로필 등록"
        type="add_profile"
        value={editingProfile}
        onChange={setEditingProfile}
        onClose={closeModal}
        onSave={handleAddProfile}
      />
    )}

    <div className={styles.infoCard}>
      <div className={styles.infoTitleWrapper}>
          <h2 className={styles.infoTitle}>사용자 프로필</h2>
          {profiles.length < 5 && (<InnocodeButton  onClick={() => showAddProfile()}>프로필 추가</InnocodeButton>)}
      </div>

      <div className={styles.profileList}> 
        {profiles.map((profile, idx) => {
          const image = profile.profile_img_url || "https://cdn-icons-png.flaticon.com/512/149/149071.png";

          return (
            <div
              key={profile.profile_id || idx}
              className={styles.infoItem}
              onClick={() => handleProfileClick(profile)}
            >
              <img
                src={image}
                alt="프로필 이미지"
                className={styles.profileImage}
              />
              <span className={styles.infoItemValue}>
                {profile.profile_name}
                <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m9 5 7 7-7 7"/>
                </svg>

              </span>
            </div>
          );
        })}
      </div>

      {/* {profiles.length < 5 && (
        <button className={styles.profileAddButton} onClick={() => showAddProfile()}>+ 프로필 추가</button>
      )} */}
    </div>
  </>
);
}

export default ProfilesPanel;